/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const sync = /* GraphQL */ `query Sync($id: String) {
  sync(id: $id)
}
` as GeneratedQuery<APITypes.SyncQueryVariables, APITypes.SyncQuery>;
export const getResident = /* GraphQL */ `query GetResident($id: ID!) {
  getResident(id: $id) {
    id
    phone
    email
    personalEmail
    groupRead
    groupWrite
    internalId
    externalId
    activeAdmission
    activeCommunityNumber
    activeCommunity
    firstAdmission
    mrn
    address {
      addressLine1
      addressLine2
      city
      state
      zipcode
      __typename
    }
    birthDate
    deathDate
    gender
    firstName
    middleName
    lastName
    activeAdmissionId
    activeLevelOfCare
    onLeave
    leaveStartDate
    activeAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    previousAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    preferredName
    covidVaccineRound
    community
    bed
    room
    floor
    building
    lOfCare
    currentIntakeId
    locations
    status
    activationStatus
    activationStartDate
    activationEndDate
    pingAccessStartDate
    lastLoginDateTime
    personType
    salesforceID
    touchtownUpdatedAt
    active
    locked
    locationID
    type
    contactInfo {
      street1
      street2
      city
      state
      zip
      phones {
        value
        type
        preferred
        hidden
        __typename
      }
      __typename
    }
    cell
    preferences {
      fontSize
      __typename
    }
    profile {
      includeInDirectory
      externalCalendarEnabled
      aboutMe
      birthPlace
      favoriteThings
      interests
      profession
      __typename
    }
    customData {
      mrn
      mealPlan {
        type
        title
        description
        period
        balance
        total
        __typename
      }
      __typename
    }
    preferredFirstName
    note
    touchtownUpdateStatus
    openSearchStatus
    salesforceProfileID
    touchTownUpdatedBy
    updatedBy
    myUnityPhones {
      value
      type
      preferred
      hidden
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResidentQueryVariables,
  APITypes.GetResidentQuery
>;
export const listResidents = /* GraphQL */ `query ListResidents(
  $filter: ModelResidentFilterInput
  $limit: Int
  $nextToken: String
) {
  listResidents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      phone
      email
      personalEmail
      groupRead
      groupWrite
      internalId
      externalId
      activeAdmission
      activeCommunityNumber
      activeCommunity
      firstAdmission
      mrn
      address {
        addressLine1
        addressLine2
        city
        state
        zipcode
        __typename
      }
      birthDate
      deathDate
      gender
      firstName
      middleName
      lastName
      activeAdmissionId
      activeLevelOfCare
      onLeave
      leaveStartDate
      activeAdmissions {
        admissionId
        community
        levelOfCare
        dateActive
        dateInactive
        bed
        room
        floor
        building
        onLeave
        leaveStartDate
        __typename
      }
      previousAdmissions {
        admissionId
        community
        levelOfCare
        dateActive
        dateInactive
        bed
        room
        floor
        building
        onLeave
        leaveStartDate
        __typename
      }
      preferredName
      covidVaccineRound
      community
      bed
      room
      floor
      building
      lOfCare
      currentIntakeId
      locations
      status
      activationStatus
      activationStartDate
      activationEndDate
      pingAccessStartDate
      lastLoginDateTime
      personType
      salesforceID
      touchtownUpdatedAt
      active
      locked
      locationID
      type
      contactInfo {
        street1
        street2
        city
        state
        zip
        phones {
          value
          type
          preferred
          hidden
          __typename
        }
        __typename
      }
      cell
      preferences {
        fontSize
        __typename
      }
      profile {
        includeInDirectory
        externalCalendarEnabled
        aboutMe
        birthPlace
        favoriteThings
        interests
        profession
        __typename
      }
      customData {
        mrn
        mealPlan {
          type
          title
          description
          period
          balance
          total
          __typename
        }
        __typename
      }
      preferredFirstName
      note
      touchtownUpdateStatus
      openSearchStatus
      salesforceProfileID
      touchTownUpdatedBy
      updatedBy
      myUnityPhones {
        value
        type
        preferred
        hidden
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResidentsQueryVariables,
  APITypes.ListResidentsQuery
>;
export const residentByMRN = /* GraphQL */ `query ResidentByMRN(
  $mrn: String!
  $sortDirection: ModelSortDirection
  $filter: ModelResidentFilterInput
  $limit: Int
  $nextToken: String
) {
  residentByMRN(
    mrn: $mrn
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      phone
      email
      personalEmail
      groupRead
      groupWrite
      internalId
      externalId
      activeAdmission
      activeCommunityNumber
      activeCommunity
      firstAdmission
      mrn
      address {
        addressLine1
        addressLine2
        city
        state
        zipcode
        __typename
      }
      birthDate
      deathDate
      gender
      firstName
      middleName
      lastName
      activeAdmissionId
      activeLevelOfCare
      onLeave
      leaveStartDate
      activeAdmissions {
        admissionId
        community
        levelOfCare
        dateActive
        dateInactive
        bed
        room
        floor
        building
        onLeave
        leaveStartDate
        __typename
      }
      previousAdmissions {
        admissionId
        community
        levelOfCare
        dateActive
        dateInactive
        bed
        room
        floor
        building
        onLeave
        leaveStartDate
        __typename
      }
      preferredName
      covidVaccineRound
      community
      bed
      room
      floor
      building
      lOfCare
      currentIntakeId
      locations
      status
      activationStatus
      activationStartDate
      activationEndDate
      pingAccessStartDate
      lastLoginDateTime
      personType
      salesforceID
      touchtownUpdatedAt
      active
      locked
      locationID
      type
      contactInfo {
        street1
        street2
        city
        state
        zip
        phones {
          value
          type
          preferred
          hidden
          __typename
        }
        __typename
      }
      cell
      preferences {
        fontSize
        __typename
      }
      profile {
        includeInDirectory
        externalCalendarEnabled
        aboutMe
        birthPlace
        favoriteThings
        interests
        profession
        __typename
      }
      customData {
        mrn
        mealPlan {
          type
          title
          description
          period
          balance
          total
          __typename
        }
        __typename
      }
      preferredFirstName
      note
      touchtownUpdateStatus
      openSearchStatus
      salesforceProfileID
      touchTownUpdatedBy
      updatedBy
      myUnityPhones {
        value
        type
        preferred
        hidden
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ResidentByMRNQueryVariables,
  APITypes.ResidentByMRNQuery
>;
export const searchResidents = /* GraphQL */ `query SearchResidents(
  $filter: SearchableResidentFilterInput
  $sort: [SearchableResidentSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableResidentAggregationInput]
) {
  searchResidents(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      phone
      email
      personalEmail
      groupRead
      groupWrite
      internalId
      externalId
      activeAdmission
      activeCommunityNumber
      activeCommunity
      firstAdmission
      mrn
      address {
        addressLine1
        addressLine2
        city
        state
        zipcode
        __typename
      }
      birthDate
      deathDate
      gender
      firstName
      middleName
      lastName
      activeAdmissionId
      activeLevelOfCare
      onLeave
      leaveStartDate
      activeAdmissions {
        admissionId
        community
        levelOfCare
        dateActive
        dateInactive
        bed
        room
        floor
        building
        onLeave
        leaveStartDate
        __typename
      }
      previousAdmissions {
        admissionId
        community
        levelOfCare
        dateActive
        dateInactive
        bed
        room
        floor
        building
        onLeave
        leaveStartDate
        __typename
      }
      preferredName
      covidVaccineRound
      community
      bed
      room
      floor
      building
      lOfCare
      currentIntakeId
      locations
      status
      activationStatus
      activationStartDate
      activationEndDate
      pingAccessStartDate
      lastLoginDateTime
      personType
      salesforceID
      touchtownUpdatedAt
      active
      locked
      locationID
      type
      contactInfo {
        street1
        street2
        city
        state
        zip
        phones {
          value
          type
          preferred
          hidden
          __typename
        }
        __typename
      }
      cell
      preferences {
        fontSize
        __typename
      }
      profile {
        includeInDirectory
        externalCalendarEnabled
        aboutMe
        birthPlace
        favoriteThings
        interests
        profession
        __typename
      }
      customData {
        mrn
        mealPlan {
          type
          title
          description
          period
          balance
          total
          __typename
        }
        __typename
      }
      preferredFirstName
      note
      touchtownUpdateStatus
      openSearchStatus
      salesforceProfileID
      touchTownUpdatedBy
      updatedBy
      myUnityPhones {
        value
        type
        preferred
        hidden
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchResidentsQueryVariables,
  APITypes.SearchResidentsQuery
>;
export const getIDMSLogRecordV1 = /* GraphQL */ `query GetIDMSLogRecordV1($id: ID!) {
  getIDMSLogRecordV1(id: $id) {
    id
    level
    action
    objectId
    oldMessage
    message
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetIDMSLogRecordV1QueryVariables,
  APITypes.GetIDMSLogRecordV1Query
>;
export const listIDMSLogRecordV1s = /* GraphQL */ `query ListIDMSLogRecordV1s(
  $filter: ModelIDMSLogRecordV1FilterInput
  $limit: Int
  $nextToken: String
) {
  listIDMSLogRecordV1s(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      level
      action
      objectId
      oldMessage
      message
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIDMSLogRecordV1sQueryVariables,
  APITypes.ListIDMSLogRecordV1sQuery
>;
export const searchIDMSLogRecordV1s = /* GraphQL */ `query SearchIDMSLogRecordV1s(
  $filter: SearchableIDMSLogRecordV1FilterInput
  $sort: [SearchableIDMSLogRecordV1SortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableIDMSLogRecordV1AggregationInput]
) {
  searchIDMSLogRecordV1s(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      level
      action
      objectId
      oldMessage
      message
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchIDMSLogRecordV1sQueryVariables,
  APITypes.SearchIDMSLogRecordV1sQuery
>;
